export const talentsDataOpsUpdated = [
  {
    id: 48,
    name: '石海波',
    role: '工作流优化师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20business%20process%20analyst%20in%20modern%20office%20attire%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20confident%20expression%2C%20age%2032%2C%20realistic%20photography&width=400&height=600&seq=talent-048&orientation=portrait',
    salary: '¥1150/月',
    tags: ['流程建模', '瓶颈识别', '自动化方案', '效率提升', 'BPMN', '流程优化'],
    description: '业务流程分析与自动化优化专家，擅长识别流程瓶颈并设计自动化解决方案，帮助企业提升运营效率。',
    skills: [{ name: '流程建模能力', level: 92 }, { name: '瓶颈分析能力', level: 89 }, { name: '自动化设计', level: 87 }, { name: '数据分析能力', level: 85 }, { name: '方案落地能力', level: 88 }],
    cases: [
      { title: '某制造企业订单处理流程优化', result: '通过流程重组和自动化改造，将订单处理时间从平均4小时缩短至45分钟，效率提升80%，错误率降低90%', duration: '2个月', tags: ['制造行业', '订单管理', '流程自动化', '效率提升'] },
      { title: '某电商公司售后流程再造', result: '重新设计售后处理流程，引入智能分流和自动审批，客户满意度从72%提升至91%，处理效率提升65%', duration: '6周', tags: ['电商行业', '售后服务', '流程再造', '客户满意度'] },
    ],
    reviews: [
      { name: '李总', company: '某制造集团', rating: 5, content: '石海波对我们的生产流程做了全面诊断，发现了很多我们自己都没意识到的问题。他设计的优化方案非常实用，实施后效果立竿见影。', date: '2024-01-15' },
      { name: '张经理', company: '某电商平台', rating: 5, content: '专业能力很强，不仅能发现问题，还能给出可落地的解决方案。流程优化后，我们团队的工作效率明显提升，加班时间也减少了。', date: '2024-02-08' },
    ],
    profile: {
      identity: { roleName: '业务流程优化专家', personality: '逻辑严谨、善于分析、注重实效', background: '工业工程专业背景，精通BPMN流程建模、六西格玛方法论' },
      mission: { duties: '负责业务流程诊断分析、瓶颈识别、优化方案设计', goals: '通过流程优化帮助企业提升运营效率30%以上', collaboration: '与业务部门深度合作，与IT团队协同实施自动化方案' },
      delivery: { example: '输出完整的流程优化报告', workflow: '1.现状调研 → 2.瓶颈识别 → 3.优化方案 → 4.实施指导 → 5.效果评估', format: '提供BPMN流程图、优化对比分析表、ROI计算报告' },
      metrics: { quality: '流程优化方案的可落地性和实际效果', acceptance: '优化方案获得业务部门认可，实施后效率提升达到预期目标', improvement: '持续跟踪优化效果，建立流程优化的长效机制' },
    },
  },
  {
    id: 49,
    name: '毛玉华',
    role: '实验追踪员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20data%20analyst%20in%20business%20casual%20attire%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20focused%20expression%2C%20age%2028%2C%20realistic%20photography&width=400&height=600&seq=talent-049&orientation=portrait',
    salary: '¥1063/月',
    tags: ['A/B测试', '实验设计', '数据分析', '统计分析', '决策支持', '效果评估'],
    description: 'A/B测试管理专家，擅长实验设计、数据分析和效果评估，为产品优化和业务决策提供数据支持。',
    skills: [{ name: '实验设计能力', level: 90 }, { name: '统计分析能力', level: 88 }, { name: '数据解读能力', level: 91 }, { name: '工具使用能力', level: 86 }, { name: '报告撰写能力', level: 87 }],
    cases: [
      { title: '某电商APP首页改版A/B测试', result: '设计并执行3组对照实验，最终选定的方案使转化率提升18%，为公司增加月收入200万元', duration: '4周', tags: ['电商行业', 'APP优化', 'A/B测试', '转化率提升'] },
      { title: '某SaaS产品定价策略测试', result: '设计多维度定价实验，找到最优定价策略，使付费转化率提升25%，客单价提升15%', duration: '6周', tags: ['SaaS行业', '定价策略', '多变量测试', '收入优化'] },
    ],
    reviews: [
      { name: '刘总监', company: '某电商平台', rating: 5, content: '毛玉华的实验设计非常严谨，统计分析专业可靠。她能够把复杂的数据分析结果用简单易懂的方式呈现，帮助我们做出正确的决策。', date: '2024-01-22' },
      { name: '张产品经理', company: '某SaaS公司', rating: 5, content: '专业能力很强，对实验设计的各种细节都考虑得很周到。她帮我们避免了很多常见的实验陷阱，确保了测试结果的可靠性。', date: '2024-02-15' },
    ],
    profile: {
      identity: { roleName: 'A/B测试与实验管理专家', personality: '严谨细致、逻辑清晰、数据敏感', background: '统计学或数据科学专业背景，精通实验设计方法、假设检验' },
      mission: { duties: '负责实验方案设计、流量分配、数据收集、统计分析、结果解读', goals: '通过科学的实验方法帮助产品和业务团队做出数据驱动的决策', collaboration: '与产品经理协作设计实验方案，与工程团队配合实施流量分割' },
      delivery: { example: '输出完整的实验报告', workflow: '1.明确目标 → 2.设计方案 → 3.配置流量 → 4.监控运行 → 5.数据分析 → 6.结果解读', format: '提供实验设计文档、数据分析报告、可视化图表、决策建议书' },
      metrics: { quality: '实验设计的科学性、统计分析的准确性', acceptance: '实验结果通过统计显著性检验，决策建议被采纳并产生预期效果', improvement: '持续优化实验设计方法，建立实验知识库' },
    },
  },
  {
    id: 50,
    name: '邱淑珍',
    role: '报告分发师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20IT%20specialist%20in%20business%20shirt%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20reliable%20expression%2C%20age%2035%2C%20realistic%20photography&width=400&height=600&seq=talent-050&orientation=portrait',
    salary: '¥938/月',
    tags: ['自动化推送', '多渠道分发', '定时任务', '格式转换', '邮件营销', '报表管理'],
    description: '自动化报告分发专家，擅长多渠道报告推送和定时任务配置，确保各类报告准时准确送达相关人员。',
    skills: [{ name: '自动化配置', level: 88 }, { name: '多渠道集成', level: 86 }, { name: '格式转换能力', level: 85 }, { name: '任务调度能力', level: 89 }, { name: '问题排查能力', level: 84 }],
    cases: [
      { title: '某集团公司报表自动化分发系统', result: '搭建覆盖邮件、钉钉、企业微信的多渠道报告分发系统，每日自动推送80+份报表，准时率99.8%，节省人工时间90%', duration: '1个月', tags: ['集团企业', '多渠道推送', '自动化系统'] },
      { title: '某零售连锁店铺日报自动化', result: '为300+门店配置个性化日报推送，店长满意度95%，数据及时性从次日提升至当日', duration: '3周', tags: ['零售行业', '门店管理', '个性化推送'] },
    ],
    reviews: [
      { name: '赵总', company: '某集团公司', rating: 5, content: '邱淑珍搭建的报告分发系统非常稳定可靠，运行一年多从未出过问题。她对各种推送渠道都很熟悉，配置起来又快又好。', date: '2024-01-18' },
      { name: '孙经理', company: '某零售连锁', rating: 5, content: '她帮我们实现了报表推送的完全自动化，不仅节省了大量人工时间，还提高了数据的及时性和准确性。非常专业！', date: '2024-02-25' },
    ],
    profile: {
      identity: { roleName: '报告自动化分发专家', personality: '细心负责、技术扎实、注重稳定性', background: '计算机或信息管理专业背景，精通任务调度、邮件服务、API集成' },
      mission: { duties: '负责报告分发系统的搭建、配置、维护，确保各类报告按时准确送达', goals: '实现报告分发的全自动化，准时率达到99%以上', collaboration: '与数据团队对接报告生成，与IT团队协作系统集成' },
      delivery: { example: '输出自动化分发系统，支持邮件、钉钉、企业微信等多渠道推送', workflow: '1.需求调研 → 2.渠道对接 → 3.任务配置 → 4.格式转换 → 5.测试验证 → 6.上线运行', format: '提供系统配置文档、推送日志报表、用户使用手册' },
      metrics: { quality: '推送准时率、推送成功率、系统稳定性', acceptance: '报告按时送达，格式正确，内容完整，用户反馈良好', improvement: '持续优化推送策略，提升系统性能，增加新的推送渠道' },
    },
  },
  {
    id: 51,
    name: '郑强强',
    role: '销售数据提取师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20data%20specialist%20in%20modern%20business%20attire%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20detail-oriented%20expression%2C%20age%2029%2C%20realistic%20photography&width=400&height=600&seq=talent-051&orientation=portrait',
    salary: '¥1100/月',
    tags: ['数据清洗', 'CRM数据', '销售分析', '线索评分', 'ETL', '数据质量'],
    description: '电商数据分析与优化专家，擅长分析电商后台数据，优化店铺设置，通过数据驱动提升销售业绩。',
    skills: [{ name: '数据提取能力', level: 90 }, { name: '数据清洗能力', level: 92 }, { name: 'SQL查询能力', level: 88 }, { name: '数据建模能力', level: 85 }, { name: '工具使用能力', level: 87 }],
    cases: [
      { title: '某B2B企业CRM数据清洗项目', result: '清洗整理50万条客户数据，去重率达到95%，数据完整性从62%提升至94%', duration: '2个月', tags: ['B2B行业', 'CRM清洗', '数据去重', '质量提升'] },
      { title: '某电商平台销售数据分析', result: '分析电商后台数据，识别高潜品类，优化店铺设置，销售额提升35%', duration: '3个月', tags: ['电商分析', '数据优化', '销售提升'] },
    ],
    reviews: [
      { name: '陈总监', company: '某B2B企业', rating: 5, content: '郑强强对数据的处理非常专业，他清洗后的数据质量很高，大大提升了我们销售团队的工作效率。他还能发现数据中的问题并提出改进建议。', date: '2024-01-20' },
      { name: '李经理', company: '某电商平台', rating: 5, content: '他的电商数据分析非常深入，帮我们找到了很多优化空间。他的建议都很实用，数据驱动的方案让销售额提升明显。', date: '2024-02-28' },
    ],
    profile: {
      identity: { roleName: '电商数据分析与优化专家', personality: '细致严谨、逻辑清晰、注重质量', background: '数据科学或信息管理专业背景，精通SQL、Python、ETL工具' },
      mission: { duties: '负责电商数据分析、销售数据提取清洗、数据质量管理', goals: '通过数据分析驱动销售业绩提升，数据质量达到95%以上', collaboration: '与销售团队了解数据需求，与IT团队对接系统接口' },
      delivery: { example: '输出清洗后的销售数据表、数据质量报告、优化建议', workflow: '1.数据提取 → 2.数据探查 → 3.清洗规则 → 4.数据清洗 → 5.质量检查 → 6.分析报告', format: '提供标准化的数据表、数据字典、清洗日志、质量报告' },
      metrics: { quality: '数据准确率、完整率、一致性', acceptance: '数据质量达到业务要求，无重大数据错误', improvement: '持续优化清洗规则，提升数据质量，建立数据质量监控体系' },
    },
  },
  {
    id: 52,
    name: '周卫东',
    role: '高管摘要师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20business%20analyst%20in%20formal%20suit%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20executive%20presence%2C%20age%2038%2C%20realistic%20photography&width=400&height=600&seq=talent-052&orientation=portrait',
    salary: '¥1500/月',
    tags: ['项目跟踪', '任务分配', '会议纪要', '汇报生成', '进度管理', '战略汇报'],
    description: '项目进度跟踪、任务分配、会议纪要与汇报生成专家，擅长将复杂的项目信息提炼为清晰的进度报告和战略摘要。',
    skills: [{ name: '数据提炼能力', level: 93 }, { name: '趋势分析能力', level: 91 }, { name: '风险识别能力', level: 89 }, { name: 'PPT制作能力', level: 92 }, { name: '高管沟通能力', level: 90 }],
    cases: [
      { title: '某上市公司项目进度管理', result: '为多个项目团队提供进度跟踪和汇报生成服务，汇报效率提升60%，项目按时交付率提升至92%', duration: '持续服务', tags: ['项目管理', '进度跟踪', '汇报生成'] },
      { title: '某集团公司战略规划支持', result: '整合市场、竞争、内部数据，提供清晰的战略建议，帮助公司确定未来3年发展方向', duration: '2个月', tags: ['战略规划', '市场分析', '决策支持'] },
    ],
    reviews: [
      { name: '张董事长', company: '某上市公司', rating: 5, content: '周卫东准备的汇报材料总是能抓住重点，逻辑清晰，数据可靠。他能够把复杂的业务情况用简单的方式呈现，节省了我们大量时间。', date: '2024-01-25' },
      { name: '李CEO', company: '某集团公司', rating: 5, content: '他对业务的理解很深刻，不仅能提供数据，还能提供有价值的洞察和建议。他的分析总是能帮我看到问题的本质。', date: '2024-02-18' },
    ],
    profile: {
      identity: { roleName: '项目协调与高管汇报专家', personality: '思维敏捷、逻辑严密、善于提炼', background: '商业分析或项目管理专业背景，具备深厚的商业洞察力' },
      mission: { duties: '负责项目进度跟踪、任务分配协调、会议纪要生成、汇报材料制作', goals: '为团队和管理层提供清晰的项目全貌，支持高效决策', collaboration: '与各业务部门收集信息，向高管汇报并接受反馈' },
      delivery: { example: '输出项目进度报告、会议纪要、高管汇报PPT', workflow: '1.信息收集 → 2.数据整合 → 3.关键信息提炼 → 4.材料制作 → 5.汇报呈现', format: '提供进度报告、PPT简报、会议纪要等标准化交付物' },
      metrics: { quality: '信息的准确性、提炼的精准度、汇报的清晰度', acceptance: '管理层认可汇报内容，项目按时推进', improvement: '持续优化汇报模板，提高沟通效率' },
    },
  },
  {
    id: 53,
    name: '龙宇生',
    role: '财务追踪员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20financial%20analyst%20in%20business%20attire%2C%20clean%20simple%20background%2C%20corporate%20headshot%20style%2C%20meticulous%20expression%2C%20age%2031%2C%20realistic%20photography&width=400&height=600&seq=talent-053&orientation=portrait',
    salary: '¥1188/月',
    tags: ['财务分析', '预算管理', '成本分析', '财务预测', '异常预警', '合规审查'],
    description: '财务分析与预算管理专家，擅长费用监控、成本分析和财务预测，帮助企业实现精细化财务管理。',
    skills: [{ name: '费用监控能力', level: 91 }, { name: '预算管理能力', level: 89 }, { name: '成本分析能力', level: 90 }, { name: '财务预测能力', level: 87 }, { name: '异常识别能力', level: 88 }],
    cases: [
      { title: '某互联网公司费用管控项目', result: '建立全面的费用监控体系，实时追踪各部门费用支出，年度费用节省15%，约800万元', duration: '持续服务', tags: ['互联网行业', '费用管控', '成本节约'] },
      { title: '某制造企业预算管理优化', result: '优化预算编制和执行流程，建立预算预警机制，预算执行准确率从78%提升至95%', duration: '3个月', tags: ['制造行业', '预算管理', '流程优化'] },
    ],
    reviews: [
      { name: '周CFO', company: '某互联网公司', rating: 5, content: '龙宇生对财务数据非常敏感，总能及时发现异常支出。他的监控报告帮助我们堵住了很多费用漏洞，为公司节省了大量成本。', date: '2024-01-28' },
      { name: '吴财务总监', company: '某制造企业', rating: 5, content: '他对预算管理的理解很深刻，不仅能监控执行情况，还能提供优化建议。他的工作让我们的预算管理水平上了一个台阶。', date: '2024-02-20' },
    ],
    profile: {
      identity: { roleName: '财务分析与预算管理专家', personality: '细致严谨、数字敏感、责任心强', background: '财务管理或会计专业背景，精通财务分析、预算管理、成本控制' },
      mission: { duties: '负责费用监控、预算执行跟踪、成本分析、财务预测、异常预警', goals: '确保预算执行准确率达到95%以上，及时发现并预警异常支出', collaboration: '与各业务部门沟通费用需求，向管理层汇报财务状况' },
      delivery: { example: '输出费用监控报表、预算执行分析、成本结构分析、财务预测报告', workflow: '1.数据收集 → 2.费用分类 → 3.预算对比 → 4.异常识别 → 5.分析报告', format: '提供费用明细表、预算对比表、成本分析图表、预警通知' },
      metrics: { quality: '数据准确性、异常识别及时性、分析深度', acceptance: '费用数据准确无误，异常及时发现并处理，预算执行可控', improvement: '持续优化监控指标，提升预警灵敏度，完善分析模型' },
    },
  },
  {
    id: 302,
    name: '吴晓燕',
    role: '质检专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20quality%20inspector%20in%20business%20attire%20meticulous%20careful%20expression%20corporate%20office%20background%20clean%20simple%20backdrop%20professional%20portrait%20photography%20style%20age%2030%20realistic&width=400&height=600&seq=talent-302&orientation=portrait',
    salary: '¥1125/月',
    tags: ['通话质检', '服务质量', '问题发现', '评分标准', '质检报告', '改进建议'],
    description: '通话质检与服务质量评估专家，负责对客服通话、在线沟通进行质量检查，发现服务问题并提出改进建议。',
    skills: [{ name: '质检规则制定', level: 93 }, { name: '通话分析能力', level: 95 }, { name: '问题识别能力', level: 94 }, { name: '报告撰写能力', level: 92 }, { name: '改进建议能力', level: 91 }],
    cases: [
      { title: '某呼叫中心质检体系建设', result: '搭建完整的通话质检体系，每日质检500+通话，服务问题发现率提升至92%，客户满意度从78%提升至89%', duration: '2个月', tags: ['呼叫中心', '质检体系', '满意度提升'] },
      { title: '某电商客服质量优化', result: '分析客服会话质量，识别15类高频问题，针对性培训后一次解决率提升40%，差评率降低65%', duration: '3个月', tags: ['电商客服', '质量优化', '差评降低'] },
    ],
    reviews: [
      { name: '张运营总监', company: '某呼叫中心', rating: 5, content: '吴晓燕的质检工作非常专业细致，她建立的质检体系让我们的服务质量大幅提升。她发现的问题准确，改进建议也很实用。', date: '2024-01-20' },
      { name: '李客服经理', company: '某电商公司', rating: 5, content: '她的质检分析帮我们找到了服务的薄弱环节，针对性培训后效果明显。她的工作让客户满意度提升了很多。', date: '2024-02-15' },
    ],
    profile: {
      identity: { roleName: '服务质量检测专家', personality: '细心严谨、善于发现问题、沟通能力强', background: '客户服务或质量管理专业背景，精通质检规则制定和服务质量评估' },
      mission: { duties: '负责服务质量检测、通话评分、问题识别、改进建议输出', goals: '确保服务质量达标，问题发现率达到90%以上，客户满意度持续提升', collaboration: '与客服团队沟通质检结果，与培训团队配合改进' },
      delivery: { example: '输出质检评分报告、问题清单、改进建议、质量趋势分析', workflow: '1.质检规则设定 → 2.通话/会话抽检 → 3.问题识别评分 → 4.报告生成 → 5.改进反馈', format: '提供质检报告、评分表、问题清单、改进建议' },
      metrics: { quality: '问题发现率、评分准确性、报告及时性', acceptance: '质检覆盖率达标，问题准确识别，建议可落地', improvement: '持续优化质检标准，提升自动化质检能力' },
    },
  },
  {
    id: 303,
    name: '沈丹丹',
    role: '直播运营员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20live%20streaming%20anchor%20in%20stylish%20modern%20attire%20with%20live%20studio%20background%20charismatic%20engaging%20expression%20age%2027%20clean%20simple%20setting%20corporate%20portrait%20photography%20style%20realistic&width=400&height=600&seq=talent-303&orientation=portrait',
    salary: '¥1250/月',
    tags: ['数字人直播', '产品讲解', '互动答疑', '带货转化', '弹幕管理', '直播数据'],
    description: '数字人直播带货专家，负责直播间产品讲解、互动答疑，通过数字人技术实现全天候直播运营，提升带货转化率。',
    skills: [{ name: '直播话术能力', level: 94 }, { name: '产品讲解能力', level: 96 }, { name: '互动答疑能力', level: 95 }, { name: '弹幕管理能力', level: 93 }, { name: '数字人操控能力', level: 92 }],
    cases: [
      { title: '某服装品牌数字人直播', result: '搭建数字人直播间，实现7×24小时不间断直播，月度GMV稳定在150万+，节省真人主播成本70%', duration: '持续服务', tags: ['数字人直播', '7×24小时', 'GMV稳定', '成本节约'] },
      { title: '某美妆品牌直播带货', result: '运营直播间产品讲解与互动，场均观看8000+，转化率8.5%，带动新品首月销售额突破300万', duration: '3个月', tags: ['美妆带货', '高转化', '新品推广'] },
    ],
    reviews: [
      { name: '王电商总监', company: '某服装品牌', rating: 5, content: '沈丹丹的直播运营非常专业，数字人的产品讲解流畅自然。她搭建的直播间帮我们实现了全天候销售，GMV非常稳定。', date: '2024-01-25' },
      { name: '李品牌经理', company: '某美妆品牌', rating: 5, content: '她的直播带货话术很专业，互动答疑及时，转化率很高。她的工作让我们的新品上市取得了很好的成绩。', date: '2024-02-18' },
    ],
    profile: {
      identity: { roleName: '数字人直播运营专家', personality: '亲和力强、反应迅速、善于表达', background: '电商直播或数字媒体专业背景，精通直播话术、产品讲解技巧和数字人技术' },
      mission: { duties: '负责直播间产品讲解、弹幕互动答疑、下单引导、直播数据监控', goals: '提升直播转化率至8%以上，GMV持续增长', collaboration: '与运营团队制定直播计划，与选品团队确认产品信息' },
      delivery: { example: '输出直播脚本、产品讲解词、弹幕互动记录、直播数据报告', workflow: '1.产品备课 → 2.话术准备 → 3.直播执行 → 4.互动答疑 → 5.数据复盘', format: '提供直播脚本、数据报告、销售记录、改进建议' },
      metrics: { quality: '直播GMV、转化率、观看人数、互动率', acceptance: '转化率达标，GMV增长，观众满意度高', improvement: '持续优化话术，提升产品讲解专业度，改善互动质量' },
    },
  },
];
